import React from "react";
import { connect } from "react-redux";
import { Icon, Button } from "antd";
import { history } from "../../../History";
import { GoogleLogout } from "react-google-login";
import HeaderWrapper from "./Header.style";
import { startLogout } from "../../../redux/actions/Auth/AuthActions";
import {
  setOpenKeys,
  setActiveMenuItemKey,
} from "../../../redux/actions/SideMenu/SidemenuActions";

class Header extends React.Component {
  constructor() {
    super();
    this.handleLogout = this.handleLogout.bind(this);
    this.goHome = this.goHome.bind(this);
  }

  handleLogout() {
    console.log("I clicked handle logout");
    this.props.startLogout();
    history.push("/");
  }

  goHome() {
    this.props.setOpenKeys([]);
    this.props.setActiveMenuItemKey([]);
    history.push("/home");
  }

  render() {
    return (
      <HeaderWrapper>
        <Icon
          type="home"
          style={{ fontSize: 24, cursor: "pointer" }}
          theme="outlined"
          onClick={() => this.goHome()}
        />
        <Button
          className="ant-btn logout-btn"
          size="large"
          onClick={this.handleLogout}
        >
          Logout
        </Button>
      </HeaderWrapper>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  startLogout,
  setOpenKeys,
  setActiveMenuItemKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Main/Header/Header.js